import { persistor, store } from '@/app/store'
import { ScrollToTop } from '@/components/common'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App.tsx'
import { AutoPageViewComponent } from './config/analytics.tsx'
import { AttributionCapture } from './config/AttributionCapture.tsx'
import './i18n.ts'
import './index.css'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallbackComponent } from './pages/external/ExternalPremiumLogin/ErrorComponents.tsx'
import { MobileAppBanner } from './components/mobile-app-banner/index.tsx'
import { PolicyOptInsProvider } from './contexts/PolicyOptInsContext.tsx'
import { MaintenanceGate } from './pages/maintenance/MaintenanceGate.tsx'


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <PolicyOptInsProvider>
            <BrowserRouter>
              <MaintenanceGate>
                <ScrollToTop />
                <AutoPageViewComponent />
                <AttributionCapture />
                <Toaster position="bottom-center" />
                <MobileAppBanner />
                <App />
              </MaintenanceGate>
            </BrowserRouter>
          </PolicyOptInsProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </QueryClientProvider>
)
